module.exports = __webpack_public_path__ + "static/media/icon-x.a1b1e74f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-x.svg
// module id = 99
// module chunks = 0